import {
  Navigate,
  ScrollRestoration,
  useLocation,
  useNavigate,
} from "react-router-dom";
import DefaultLayout from "../layout/DefaultLayout/DefaultLayout";
import { useProfileStore } from "../store/useUserStore";
import { useEffect } from "react";

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authLogin = localStorage.getItem("parent_token");
  const { profile, fetchProfile, fetchStudents, homePageShow } =
    useProfileStore((state) => state);

  useEffect(() => {
    // Only fetch if not already fetched
    if (!profile) {
      fetchProfile();
    }
  }, [profile, fetchProfile]);

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    if (homePageShow === "school") {
      navigate("/school");
    }
  }, [homePageShow, navigate]);

  if (authLogin === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <>
      <ScrollRestoration />
      <DefaultLayout />
    </>
  );
};

export default PrivateRoutes;
